import { render } from "./PaiementSection.vue?vue&type=template&id=33254b32"
import script from "./PaiementSection.vue?vue&type=script&lang=js"
export * from "./PaiementSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__